var $d109f3d68ba24ffc$exports = {};
$d109f3d68ba24ffc$exports = {
    "(optional)": `(nepovinn\xe9)`,
    "(required)": `(povinn\xe9)`
};


export {$d109f3d68ba24ffc$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
